export default __webpack_public_path__ + "static/media/B0000.5be5111c.png";